import {
  Avatar,
  Breadcrumb,
  Button,
  Card,
  Col,
  Form,
  Input,
  message,
  Row,
  Select,
  Tag,
  Typography,
} from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import { POST_API } from '../../services/api';

class WebAdvogado extends React.Component {
  state = { data: [], options: [], loading: true };

  breadcrumb = [
    {
      title: (
        <Link to="/">
          <Typography className="home-breadcrumb-link">Home</Typography>
        </Link>
      ),
    },
    {
      title: (
        <Typography className="home-breadcrumb-link active">
          Advogados
        </Typography>
      ),
    },
  ];

  componentDidMount = () => {
    this.onSearch({});

    POST_API('/specialty/search.php', { token: 'X' })
      .then((rs) => rs.json())
      .then((res) => {
        if (res.return) {
          this.setState({
            options: res.data.map((item) => ({
              label: item.NAME,
              value: item.ID,
            })),
          });
        } else {
          message.warning({ content: res.msg, key: 'screen' });
        }
      })
      .catch(() => {
        message.error({
          content: 'Não foi possível estabelecer uma conexão com o sistema',
          key: 'screen',
        });
      });
  };

  onSearch = (values) => {
    this.setState({ loading: true });
    POST_API('/credential/search.php', {
      token: 'X',
      filter: JSON.stringify({ ...values, CREDENTIAL_TYPE_ID: 2 }),
    })
      .then((rs) => rs.json())
      .then((res) => {
        if (res.return) {
          this.setState({ data: res.data });
        } else {
          message.warning({ content: res.msg, key: 'screen' });
        }
        this.setState({ loading: false });
      })
      .catch(() => {
        message.error({
          content: 'Não foi possível estabelecer uma conexão com o sistema',
          key: 'screen',
        });
      });
  };

  render = () => {
    return (
      <Row>
        <Col className="home-col-black" span={24}>
          <Row align={'middle'} className="home-row-breadcrumb">
            <Col span={12}>
              <Breadcrumb className="home-breadcrumb" items={this.breadcrumb} />
            </Col>
            <Col span={12}>
              <Typography className="home-breadcrumb-title">
                Advogados
              </Typography>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row className="home-row-page" gutter={[16, 16]}>
            <Col span={24}>
              <Typography className="home-row-page-text-title">
                ADVOGADOS
              </Typography>
            </Col>
            <Col span={24}>
              <Form layout="vertical" onFinish={this.onSearch}>
                <Row align={'bottom'} gutter={[16, 0]}>
                  <Col lg={8} md={14} sm={14} xl={8} xs={24}>
                    <Form.Item label="Nome" name="NAME">
                      <Input placeholder="Busque pelo nome" type="text" />
                    </Form.Item>
                  </Col>
                  <Col lg={6} md={10} sm={10} xl={6} xs={24}>
                    <Form.Item label="Especialidade" name="SPECIALTY_ID">
                      <Select
                        allowClear
                        options={this.state.options}
                        placeholder="Busque por especialidade"
                        style={{ width: '100%' }}
                      />
                    </Form.Item>
                  </Col>
                  <Col lg={5} md={8} sm={10} xl={5} xs={16}>
                    <Form.Item label="Cidade" name="CITY">
                      <Input placeholder="Busque pela cidade" type="text" />
                    </Form.Item>
                  </Col>
                  <Col lg={2} md={4} sm={4} xl={2} xs={8}>
                    <Form.Item label="UF" name="STATE">
                      <Input placeholder="UF" type="text" />
                    </Form.Item>
                  </Col>
                  <Col lg={3} md={12} sm={10} xl={3} xs={24}>
                    <Button
                      block
                      htmlType="submit"
                      loading={this.state.loading}
                      style={{ marginBottom: 24 }}
                      type="primary"
                    >
                      Filtrar
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Col>
            {this.state.data.length > 0 ? (
              this.state.data.map((item) => (
                <Col key={item.ID} lg={12} md={12} sm={24} xl={8} xs={24}>
                  <Link to={`/advogados/${item.ID}`}>
                    <Card
                      actions={[
                        <Row
                          gutter={[4, 4]}
                          key="row"
                          style={{
                            marginLeft: 10,
                            marginRight: 10,
                            flexWrap: 'nowrap',
                            overflowX: 'auto',
                          }}
                        >
                          {item.SPECIALITY?.length > 0 ? (
                            item.SPECIALITY.map((vl) => (
                              <Col key={vl}>
                                <Tag
                                  color="var(--primary)"
                                  style={{ marginRight: 0 }}
                                >
                                  {vl}
                                </Tag>
                              </Col>
                            ))
                          ) : (
                            <Col>Sem especialidaes</Col>
                          )}
                        </Row>,
                      ]}
                      hoverable
                    >
                      <Card.Meta
                        avatar={<Avatar size={100} src={item.INTER_AVATAR} />}
                        description={
                          item.CITY ? (
                            <p>
                              {item.CITY} / {item.STATE}
                            </p>
                          ) : (
                            'Sem endereço'
                          )
                        }
                        title={item.NAME}
                      />
                    </Card>
                  </Link>
                </Col>
              ))
            ) : (
              <Col span={24}>
                <Typography>Nenhum advogado encontrado</Typography>
              </Col>
            )}
          </Row>
        </Col>
      </Row>
    );
  };
}

export default WebAdvogado;
